// File: src/pages/transporters/TransporterUpsert.jsx

import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  Card,
  CardBody,
  Col,
  Form,
  Row,
  Input,
  Label,
  Button,
  Spinner,
} from "reactstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";

import {
  _Get,
  _GetByUrlOnly,
  _PostSave,
  _Put,
  _BulkUpload,
  Get_RoleList,
} from "../import/ApiEndPoint/ApiCalling";

import {
  GST_Verification_Api,
  View_TransporterByID,
  Update_TransporterByID,
  viewpincodedata,
  viewpincodedata1,
  Create_transporter_save as Createtransportersave,
  Bulk_Upload_transporter,
  Bulk_Upate_transporterUpload,
  Image_URL,
} from "../import/ApiEndPoint/Api";

import { CheckPermission } from "../import/CheckPermission";

/* --- inline css once --- */
const ensureInlineCss = () => {
  const id = "transporter-inline-css";
  if (document.getElementById(id)) return;

  const s = document.createElement("style");
  s.id = id;
  s.textContent = `
    .sa { --fs:14px; --fs-lg:15px; --h:40px; --gap:8px; }
    .sa *{ font-size:var(--fs) !important; }
    .sa h1{ font-size:22px !important; font-weight:600; margin:0 0 6px; }
    .sa label{ font-size:13px !important; font-weight:600; margin-bottom:6px; }
    .sa input:not([type="radio"]):not([type="checkbox"]),
    .sa select,
    .sa textarea{ font-size:var(--fs-lg) !important; height:var(--h);
      padding:8px 10px; border-radius:10px; border:1px solid #d6d8e1; background:#fff; }
    .sa .btn{ border-radius:10px; padding:8px 14px; font-weight:500; }
    .sa .card-soft{ background:#f7f9ff; border:1px solid #e5e7ef; border-radius:12px; padding:12px; box-shadow: rgba(16, 24, 40, .04) 0 1px 2px; }
    .sa .row.g-tight{ row-gap: var(--gap); }
    .sa .myphoneinput{ height:var(--h) !important; font-size:var(--fs-lg) !important; padding:8px 10px !important; width:100% !important; }
    .sa .block{ border:1px solid #e5e7eb; border-radius:12px; padding:12px; background:#fff; }
    .sa .tag{ display:inline-block; background:#eef2ff; border:1px solid #e5e7eb; padding:2px 8px; border-radius:999px; font-size:12px; margin-left:6px; }
    .sa .radio-line{ display:flex; align-items:center; gap:18px; }
    .sa .radio-line label{ display:flex; align-items:center; gap:8px; margin:0; }
    .sa .mini-help{ font-size:12px !important; color:#6b7280; margin-top:6px; }
    .sa .imgbox{ border:1px dashed #cbd5e1; border-radius:12px; padding:10px; background:#fff; }
    .sa .imgprev{ width:120px; height:100px; object-fit:cover; border-radius:10px; border:1px solid #e5e7eb; }
  `;
  document.head.appendChild(s);
};

/* ================= Opening Financial Year Helpers ================= */

const normalizeOpeningFinancialYear = (value) => {
  const raw = String(value || "").trim();

  const match = raw.match(/^(\d{4})\s*-\s*(\d{2}|\d{4})$/);
  if (!match) return raw;

  const startYear = match[1];
  const endYear = match[2].length === 4 ? match[2].slice(-2) : match[2];

  return `${startYear}-${endYear}`;
};

const getFYStartYear = (date = new Date()) => {
  const d = new Date(date);
  const y = d.getFullYear();
  const m = d.getMonth();

  return m >= 3 ? y : y - 1;
};

const getCurrentOpeningFinancialYear = () => {
  const start = getFYStartYear(new Date());
  return normalizeOpeningFinancialYear(`${start}-${start + 1}`);
};

const buildOpeningFinancialYearOptions = (past = 5, future = 2) => {
  const currentStart = getFYStartYear(new Date());
  const arr = [];

  for (let y = currentStart - past; y <= currentStart + future; y++) {
    arr.push(normalizeOpeningFinancialYear(`${y}-${y + 1}`));
  }

  return arr.reverse();
};

export default function TransporterUpsert() {
  const navigate = useNavigate();
  const Params = useParams();
  const isCreate = String(Params?.id) === "0";

  ensureInlineCss();

  const openingFYOptions = useMemo(
    () => buildOpeningFinancialYearOptions(5, 2),
    [],
  );

  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const perms = CheckPermission("Create Transporter");

  const [Loading, setLoading] = useState(false);
  const [LoaderGST, setLoaderGST] = useState(false);

  const [BulkUpload, setBulkUpload] = useState(false);
  const [BulkUploadStatus, setBulkUploadStatus] = useState("");
  const [BulkImport, setBulkImport] = useState(null);
  const [BulkLoading, setBulkLoading] = useState(false);

  const [ImageFile, setImageFile] = useState(null);
  const [ImagePreview, setImagePreview] = useState("");
  const [ExistingImage, setExistingImage] = useState("");

  const [pinRows, setPinRows] = useState([]);

  const pinMap = useMemo(() => {
    const m = new Map();

    for (const r of Array.isArray(pinRows) ? pinRows : []) {
      const key = String(r?.pincode ?? "").trim();
      if (key && !m.has(key)) m.set(key, r);
    }

    return m;
  }, [pinRows]);

  const [cityOptions, setCityOptions] = useState([]);
  const [showCityDropdown, setShowCityDropdown] = useState(false);
  const [selectedCityId, setSelectedCityId] = useState("");
  const lastPinFetchRef = useRef("");

  const [form, setForm] = useState({
    companyName: "",
    id: "",
    name: "",
    contactNumber: "",
    email: "",
    pincode: "",
    City: "",
    State: "",
    address1: "",
    address2: "",
    OpeningBalance: "",
    openingFinancialYear: getCurrentOpeningFinancialYear(),
    Type: "",
    status: "Active",
    gstNumber: "",
    rolename: "",
    database: userData?.database || "",
  });

  const [serviceArea, setServiceArea] = useState([
    {
      BMName: "",
      contactNumber: "",
      address: "",
      pincode: "",
      city: "",
      state: "",
    },
  ]);

  const lookupPin = (pin) => {
    const rec = pinMap.get(String(pin));

    return {
      city: rec?.city || "",
      state: rec?.state || "",
    };
  };

  const buildPinUrl = (base, pin) => {
    const b = String(base || "");
    if (!b) return "";

    return b.includes("?") ? `${b}&pincode=${pin}` : `${b}?pincode=${pin}`;
  };

  const fetchCitiesByPincode = async (pin) => {
    const only = String(pin || "").replace(/[^\d]/g, "");
    if (only.length !== 6) return;

    if (lastPinFetchRef.current === only) return;
    lastPinFetchRef.current = only;

    try {
      const url = buildPinUrl(viewpincodedata1, only);
      if (!url) return;

      const res = await _GetByUrlOnly(url);
      const list = Array.isArray(res?.pinCodes) ? res.pinCodes : [];

      if (list.length > 1) {
        const opts = list.map((x) => {
          const city = x?.city || "";
          const district = x?.district || "";
          const state = x?.state || "";

          return {
            _id: x?._id || `${city}-${district}-${state}-${only}`,
            city,
            district,
            state,
            pincode: x?.pincode || only,
            label: district ? `${city} (${district})` : city,
          };
        });

        setCityOptions(opts);
        setShowCityDropdown(true);

        const st = opts?.[0]?.state || "";

        setForm((p) => ({
          ...p,
          pincode: only,
          State: st || p.State,
          City: p.City || "",
        }));

        const currentCity = String(form?.City || "");

        if (currentCity) {
          const match =
            opts.find((o) => String(o.city) === currentCity) || null;
          setSelectedCityId(match ? match._id : "");
        } else {
          setSelectedCityId("");
        }

        return;
      }

      if (list.length === 1) {
        const one = list[0];
        const city = one?.city || "";
        const state = one?.state || "";
        const district = one?.district || "";

        setCityOptions([
          {
            _id: one?._id || `${city}-${district}-${state}-${only}`,
            city,
            district,
            state,
            pincode: one?.pincode || only,
            label: district ? `${city} (${district})` : city,
          },
        ]);

        setShowCityDropdown(false);
        setSelectedCityId("");

        setForm((p) => ({
          ...p,
          pincode: only,
          City: city,
          State: state,
        }));

        return;
      }

      setCityOptions([]);
      setShowCityDropdown(false);
      setSelectedCityId("");

      const { city, state } = lookupPin(only);

      setForm((p) => ({
        ...p,
        pincode: only,
        City: city,
        State: state,
      }));
    } catch (e) {
      setCityOptions([]);
      setShowCityDropdown(false);
      setSelectedCityId("");

      const { city, state } = lookupPin(only);

      setForm((p) => ({
        ...p,
        pincode: only,
        City: city,
        State: state,
      }));
    }
  };

  const setField = (k, v) => {
    if (k === "companyName") {
      const noSpace = (v || "").replace(/\s+/g, "");
      setForm((p) => ({ ...p, companyName: v, id: p.id || noSpace }));
      return;
    }

    if (k === "openingFinancialYear") {
      setForm((p) => ({
        ...p,
        openingFinancialYear: normalizeOpeningFinancialYear(v),
      }));
      return;
    }

    if (k === "pincode") {
      const only = String(v || "")
        .replace(/[^\d]/g, "")
        .slice(0, 6);

      setForm((p) => ({
        ...p,
        pincode: only,
        City: only.length < 6 ? "" : p.City,
        State: only.length < 6 ? "" : p.State,
      }));

      if (only.length === 6) {
        fetchCitiesByPincode(only);
      } else {
        lastPinFetchRef.current = "";
        setCityOptions([]);
        setShowCityDropdown(false);
        setSelectedCityId("");
      }

      return;
    }

    setForm((p) => ({ ...p, [k]: v }));
  };

  const handleCitySelect = (e) => {
    const id = e.target.value || "";
    setSelectedCityId(id);

    const opt = (cityOptions || []).find((o) => String(o._id) === String(id));

    if (!opt) {
      setForm((p) => ({ ...p, City: "", State: p.State || "" }));
      return;
    }

    setForm((p) => ({
      ...p,
      City: opt.city || "",
      State: opt.state || p.State || "",
    }));
  };

  const onSAChange = (i, k, v) =>
    setServiceArea((prev) => {
      const n = [...prev];
      n[i] = { ...n[i], [k]: v };
      return n;
    });

  const onSAPincode = (i, pin) => {
    const { city, state } = lookupPin(pin);

    onSAChange(i, "pincode", pin);
    onSAChange(i, "city", city);
    onSAChange(i, "state", state);
  };

  const addService = () =>
    setServiceArea((p) => [
      ...p,
      {
        BMName: "",
        contactNumber: "",
        address: "",
        pincode: "",
        city: "",
        state: "",
      },
    ]);

  const removeService = (idx) =>
    setServiceArea((p) => p.filter((_, i) => i !== idx));

  const handleGST = async (valRaw) => {
    const value = String(valRaw || "")
      .toUpperCase()
      .replace(/\s/g, "");

    setField("gstNumber", value);

    if (value.length !== 15) return;

    try {
      setLoaderGST(true);

      const res = await _Get(GST_Verification_Api, value);
      const ok = !!res?.flag;

      if (ok) {
        const adr = res?.data?.pradr?.adr || "";
        const parts = adr.split(",");
        const part1 = (parts[0] || "").trim();
        const part2 = parts.slice(1).join(",").trim();

        setForm((p) => ({
          ...p,
          companyName: res?.data?.tradeNam || p.companyName,
          address1: p.address1 || part1 || "",
          address2: p.address2 || part2 || "",
          gstNumber: value,
          id: p.id || value.slice(2, 12),
        }));
      } else {
        setForm((p) => ({
          ...p,
          gstNumber: value,
          id: p.id || value.slice(2, 12),
        }));
      }
    } catch {
      setForm((p) => ({
        ...p,
        gstNumber: value,
        id: p.id || value.slice(2, 12),
      }));

      swal("Error", "GST verification failed", "error");
    } finally {
      setLoaderGST(false);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const res = await _GetByUrlOnly(viewpincodedata);
        const list = Array.isArray(res?.pinCodeList) ? res.pinCodeList : [];
        setPinRows(list);
      } catch (e) {
        console.error(e);
        setPinRows([]);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        if (!isCreate) return;

        const userdata = JSON.parse(localStorage.getItem("userData") || "{}");
        const res = await Get_RoleList(userdata?._id, userdata?.database);
        const list = Array.isArray(res?.Role) ? res.Role : [];

        const show = list.filter((r) =>
          String(r?.roleName || "")
            .toLowerCase()
            .includes("transporter"),
        );

        const roleId = show?.[0]?._id || "";

        if (roleId) setForm((p) => ({ ...p, rolename: roleId }));
      } catch (e) {}
    })();
  }, [isCreate]);

  useEffect(() => {
    if (isCreate && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const gt = `${pos.coords.latitude},${pos.coords.longitude}`;
          setForm((p) => ({ ...p, geotagging: gt }));
        },
        () => {},
        { timeout: 10000, enableHighAccuracy: true },
      );
    }
  }, [isCreate]);

  useEffect(() => {
    if (!isCreate) {
      (async () => {
        try {
          setLoading(true);

          const res = await _Get(View_TransporterByID, Params?.id);
          const t = res?.Transporter || {};

          setExistingImage(t?.image || t?.Photo || t?.photo || "");

          setServiceArea(
            Array.isArray(t?.serviceArea) && t.serviceArea.length
              ? t.serviceArea.map((sa) => ({
                  ...sa,
                  contactNumber: String(sa?.contactNumber ?? ""),
                }))
              : [
                  {
                    BMName: "",
                    contactNumber: "",
                    address: "",
                    pincode: "",
                    city: "",
                    state: "",
                  },
                ],
          );

          const derived = t?.pincode
            ? lookupPin(t.pincode)
            : {
                city: t?.City || t?.city || "",
                state: t?.State || t?.state || "",
              };

          setForm((p) => ({
            ...p,
            companyName: t?.companyName || "",
            id: t?.id || "",
            name: t?.name || "",
            contactNumber: String(t?.contactNumber ?? ""),
            email: t?.email || "",
            pincode: t?.pincode || "",
            City: t?.City || t?.city || derived.city || "",
            State: t?.State || t?.state || derived.state || "",
            address1: t?.address1 || t?.address || "",
            address2: t?.address2 || "",
            OpeningBalance: t?.OpeningBalance ?? "",
            openingFinancialYear: normalizeOpeningFinancialYear(
              t?.openingFinancialYear || getCurrentOpeningFinancialYear(),
            ),
            Type: t?.Type || "",
            status: t?.status || "Active",
            gstNumber: t?.gstNumber || "",
            rolename: t?.rolename?._id || t?.rolename || p.rolename || "",
            database: userData?.database || "",
          }));

          if (String(t?.pincode || "").length === 6) {
            lastPinFetchRef.current = "";
            await fetchCitiesByPincode(String(t.pincode));
          }
        } catch (e) {
          swal("Error", "Could not load transporter", "error");
        } finally {
          setLoading(false);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreate, Params?.id, pinMap, userData?.database]);

  const onPickImage = (file) => {
    if (!file) return;

    setImageFile(file);

    const reader = new FileReader();
    reader.onload = (e) => setImagePreview(String(e.target.result || ""));
    reader.readAsDataURL(file);
  };

  const submitBulkHandler = async (e) => {
    e.preventDefault();

    if (perms && perms.Create === false) {
      return swal(
        "Permission",
        "You don't have permission to create.",
        "warning",
      );
    }

    if (!BulkUploadStatus) {
      return swal("Error", "Choose Type of Upload", "error");
    }

    if (!BulkImport) {
      return swal("Error", "Please choose a file", "error");
    }

    const ud = JSON.parse(localStorage.getItem("userData") || "{}");

    if (!ud?.database) {
      return swal("Error", "Database not found in userData", "error");
    }

    setBulkLoading(true);

    try {
      const fd = new FormData();

      fd.append("file", BulkImport);
      fd.append("database", ud.database);

      if (BulkUploadStatus === "Update") {
        const url = `${String(Bulk_Upate_transporterUpload || "").replace(
          /\/+$/,
          "",
        )}/${ud.database}`;

        const res = await _BulkUpload(url, fd);

        if (res?.status) {
          swal("Success", "Details updated successfully", "success");
          navigate(-1);
        } else {
          swal("Error", res?.message || "Error in Updating Details", "error");
        }
      } else if (BulkUploadStatus === "New Upload") {
        const url = `${String(Bulk_Upload_transporter || "").replace(
          /\/+$/,
          "",
        )}/${ud.database}`;

        const res = await _BulkUpload(url, fd);

        if (res?.status) {
          swal("Success", "Transporter added successfully", "success");
          navigate(-1);
        } else {
          swal("Error", res?.message || "Error in adding Transporter", "error");
        }
      } else {
        swal("Error", "Choose Type of Upload", "error");
      }
    } catch (err) {
      swal(
        "Error",
        err?.response?.data?.message || "Something went wrong",
        "error",
      );
    } finally {
      setBulkLoading(false);
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!form.companyName?.trim()) {
      return swal("Error", "Transporter name is required", "error");
    }

    if (!form.name?.trim()) {
      return swal("Error", "Incharge name is required", "error");
    }

    if (!form.contactNumber) {
      return swal("Error", "Contact number is required", "error");
    }

    if (!form.pincode) {
      return swal("Error", "Pincode is required", "error");
    }

    const ob = form.OpeningBalance;
    const obMissing = ob === "" || ob === null || ob === undefined;

    if (obMissing || !form.Type) {
      return swal("Error", "Opening balance & type are required", "error");
    }

    if (!form.openingFinancialYear) {
      return swal("Error", "Opening financial year is required", "error");
    }

    if (isCreate && perms && perms.Create === false) {
      return swal(
        "Permission",
        "You don't have permission to create.",
        "warning",
      );
    }

    if (!isCreate && perms && perms.Edit === false) {
      return swal(
        "Permission",
        "You don't have permission to edit.",
        "warning",
      );
    }

    setLoading(true);

    try {
      const fd = new FormData();

      const pinDerived = form.pincode
        ? lookupPin(form.pincode)
        : { city: "", state: "" };

      const cityFinal = form.City || pinDerived.city || "";
      const stateFinal = form.State || pinDerived.state || "";

      fd.set("companyName", form.companyName);
      fd.set("database", form.database || "");
      fd.set("id", form.id || form.companyName.replace(/\s+/g, ""));

      fd.set("city", cityFinal);
      fd.set("state", stateFinal);
      fd.set("City", cityFinal);
      fd.set("State", stateFinal);

      [
        "name",
        "contactNumber",
        "email",
        "pincode",
        "address1",
        "address2",
        "OpeningBalance",
        "openingFinancialYear",
        "Type",
        "status",
        "gstNumber",
        "geotagging",
        "rolename",
      ].forEach((k) => {
        const v = form[k];

        if (v !== undefined && v !== null && v !== "") {
          fd.set(k, v);
        }
      });

      fd.set(
        "openingFinancialYear",
        normalizeOpeningFinancialYear(
          form.openingFinancialYear || getCurrentOpeningFinancialYear(),
        ),
      );

      const saNorm = (serviceArea || []).map((sa) => {
        if (sa?.pincode) {
          const { city: sc, state: ss } = lookupPin(sa.pincode);

          return {
            ...sa,
            city: sa.city || sc || "",
            state: sa.state || ss || "",
          };
        }

        return { ...sa };
      });

      fd.set("serviceArea", JSON.stringify(saNorm));

      if (ImageFile) {
        fd.append("file", ImageFile);
      }

      if (isCreate) {
        const res = await _PostSave(Createtransportersave, fd);

        if (res?.status) {
          swal("Success", "Transporter Created Successfully", "success");
          navigate(-1);
        } else {
          swal("Error", res?.message || "Create failed", "error");
        }
      } else {
        const updateBase = String(Update_TransporterByID || "").replace(
          /\/+$/,
          "",
        );

        const idSafe = String(Params?.id || "").replace(/^\/+/, "");
        const res = await _Put(updateBase, idSafe, fd);

        if (res?.status) {
          swal("Success", "Transporter Updated Successfully", "success");
          navigate(-1);
        } else {
          swal("Error", res?.message || "Update failed", "error");
        }
      }
    } catch (err) {
      swal(
        "Error",
        err?.response?.data?.message || "Something went wrong",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  if (Loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10rem",
        }}
      >
        <Spinner style={{ height: "3rem", width: "3rem" }} color="primary">
          Loading...
        </Spinner>
      </div>
    );
  }

  return (
    <div className="sa">
      <Card className="card-soft" style={{ padding: 12 }}>
        <Row className="align-items-center mb-2">
          <Col />

          <Col className="text-center">
            <h1>{isCreate ? "Create" : "Edit"} Transporter</h1>
          </Col>

          <Col
            className="d-flex justify-content-end"
            lg="4"
            md="5"
            sm="12"
            style={{ gap: 8 }}
          >
            {isCreate && (
              <Button
                color="primary"
                outline
                onClick={() => {
                  if (perms && perms.Create === false) {
                    return swal(
                      "Permission",
                      "You don't have permission to create.",
                      "warning",
                    );
                  }

                  setBulkUpload((p) => !p);
                }}
              >
                {BulkUpload ? "Back" : "Bulk Upload"}
              </Button>
            )}

            <Button color="secondary" onClick={() => navigate(-1)}>
              Back
            </Button>
          </Col>
        </Row>

        {isCreate && BulkUpload ? (
          <Form onSubmit={submitBulkHandler}>
            <CardBody className="card-soft">
              <h1 className="text-center">Bulk Upload</h1>

              <Row className="g-tight">
                <Col lg="12" md="12" sm="12">
                  <Label>
                    Choose Type of Upload{" "}
                    <span style={{ color: "red" }}>*</span>
                  </Label>

                  <div
                    className="radio-line"
                    style={{ justifyContent: "center" }}
                  >
                    <label>
                      <Input
                        type="radio"
                        name="UploadStatus"
                        checked={BulkUploadStatus === "New Upload"}
                        onChange={() => setBulkUploadStatus("New Upload")}
                      />
                      <span>New Upload</span>
                    </label>

                    <label>
                      <Input
                        type="radio"
                        name="UploadStatus"
                        checked={BulkUploadStatus === "Update"}
                        onChange={() => setBulkUploadStatus("Update")}
                      />
                      <span>Update</span>
                    </label>
                  </div>
                </Col>

                <Col lg="12" md="12" sm="12">
                  <Label>
                    Upload File <span style={{ color: "red" }}>*</span>
                  </Label>

                  <div className="imgbox">
                    <Input
                      type="file"
                      onChange={(e) =>
                        setBulkImport(e.target.files?.[0] || null)
                      }
                    />

                    <div className="mini-help">
                      Upload your excel/csv file as per transporter bulk format.
                    </div>
                  </div>
                </Col>

                <Col
                  lg="12"
                  className="d-flex justify-content-center"
                  style={{ marginTop: 8 }}
                >
                  <Button color="primary" type="submit" disabled={BulkLoading}>
                    {BulkLoading ? <Spinner size="sm" /> : "Import"}
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Form>
        ) : (
          <Form onSubmit={submitHandler}>
            <Row className="g-tight">
              <Col lg="6" md="12">
                <CardBody className="card-soft">
                  <h1 className="text-center">Basic Information</h1>

                  <Row className="g-tight">
                    <Col lg="6" md="6" sm="12">
                      <Label>Transporter Name *</Label>
                      <Input
                        value={form.companyName}
                        onChange={(e) =>
                          setField("companyName", e.target.value)
                        }
                      />
                    </Col>

                    <Col lg="6" md="6" sm="12">
                      <Label>Incharge Name *</Label>
                      <Input
                        value={form.name}
                        onChange={(e) => setField("name", e.target.value)}
                      />
                    </Col>

                    <Col lg="6" md="6" sm="12">
                      <Label>Contact Number *</Label>
                      <PhoneInput
                        inputClass="myphoneinput"
                        country="in"
                        countryCodeEditable={false}
                        value={String(form.contactNumber ?? "")}
                        onChange={(v) => setField("contactNumber", String(v))}
                      />
                    </Col>

                    <Col lg="6" md="6" sm="12">
                      <Label>Email</Label>
                      <Input
                        type="email"
                        value={form.email}
                        onChange={(e) => setField("email", e.target.value)}
                      />
                    </Col>

                    <Col lg="4" md="6" sm="12">
                      <Label>Pincode *</Label>
                      <Input
                        type="number"
                        value={form.pincode}
                        onChange={(e) => setField("pincode", e.target.value)}
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                      />
                    </Col>

                    <Col lg="4" md="6" sm="12">
                      <Label>City</Label>

                      {showCityDropdown ? (
                        <Input
                          type="select"
                          value={selectedCityId || ""}
                          onChange={handleCitySelect}
                        >
                          <option value="">-- Select City --</option>
                          {cityOptions.map((o) => (
                            <option key={o._id} value={o._id}>
                              {o.label}
                            </option>
                          ))}
                        </Input>
                      ) : (
                        <Input readOnly value={form.City} />
                      )}
                    </Col>

                    <Col lg="4" md="6" sm="12">
                      <Label>State</Label>
                      <Input readOnly value={form.State} />
                    </Col>

                    <Col lg="12" md="12" sm="12">
                      <Label>Address</Label>
                      <Input
                        value={form.address1}
                        onChange={(e) => setField("address1", e.target.value)}
                      />
                    </Col>

                    <Col lg="12" md="12" sm="12">
                      <Label>Address 2</Label>
                      <Input
                        value={form.address2}
                        onChange={(e) => setField("address2", e.target.value)}
                      />
                    </Col>

                    <Col lg="4" md="6" sm="12">
                      <Label>Opening Financial Year *</Label>
                      <Input
                        type="select"
                        value={
                          form.openingFinancialYear ||
                          getCurrentOpeningFinancialYear()
                        }
                        onChange={(e) =>
                          setField(
                            "openingFinancialYear",
                            normalizeOpeningFinancialYear(e.target.value),
                          )
                        }
                      >
                        {openingFYOptions.map((fy) => (
                          <option key={fy} value={fy}>
                            {fy}
                          </option>
                        ))}
                      </Input>
                    </Col>

                    <Col lg="4" md="6" sm="12">
                      <Label>Opening Balance *</Label>
                      <Input
                        type="number"
                        value={form.OpeningBalance}
                        onChange={(e) =>
                          setField("OpeningBalance", e.target.value)
                        }
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                      />
                    </Col>

                    <Col lg="4" md="6" sm="12">
                      <Label>O/P Balance Type *</Label>
                      <Input
                        type="select"
                        value={form.Type}
                        onChange={(e) => setField("Type", e.target.value)}
                      >
                        <option value="">-- Select --</option>
                        <option value="debit">Dr</option>
                        <option value="credit">Cr</option>
                      </Input>
                    </Col>

                    <Col lg="4" md="12" sm="12">
                      <Label>Status</Label>
                      <div className="radio-line">
                        <label>
                          <Input
                            type="radio"
                            name="status"
                            checked={
                              String(form.status).toLowerCase() === "active"
                            }
                            onChange={() => setField("status", "Active")}
                          />
                          <span>Active</span>
                        </label>

                        <label>
                          <Input
                            type="radio"
                            name="status"
                            checked={
                              String(form.status).toLowerCase() === "deactive"
                            }
                            onChange={() => setField("status", "Deactive")}
                          />
                          <span>Deactive</span>
                        </label>
                      </div>
                    </Col>

                    <Col lg="6" md="6" sm="12">
                      <Label>GST Number</Label>
                      <Input
                        value={form.gstNumber}
                        onChange={(e) => handleGST(e.target.value)}
                        minLength={15}
                        maxLength={15}
                      />

                      {LoaderGST && (
                        <div style={{ color: "red" }}>
                          Getting GST Information..
                        </div>
                      )}
                    </Col>

                    <Col lg="6" md="6" sm="12">
                      <Label>Image</Label>

                      <div className="imgbox">
                        <Input
                          type="file"
                          accept="image/*"
                          onChange={(e) => onPickImage(e.target.files?.[0])}
                        />

                        <div className="mini-help">
                          Optional: upload transporter image/logo.
                        </div>

                        <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
                          {ImagePreview ? (
                            <img
                              className="imgprev"
                              src={ImagePreview}
                              alt="preview"
                            />
                          ) : null}

                          {!ImagePreview && ExistingImage ? (
                            <img
                              className="imgprev"
                              src={`${Image_URL}/Images/${ExistingImage}`}
                              alt="existing"
                            />
                          ) : null}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Col>

              <Col lg="6" md="12">
                <CardBody className="card-soft">
                  <h1 className="text-center">
                    Service Locations{" "}
                    <span className="tag">{serviceArea.length}</span>
                  </h1>

                  {serviceArea.map((s, idx) => (
                    <div
                      key={idx}
                      className="block"
                      style={{ marginBottom: 10 }}
                    >
                      <Row className="g-tight">
                        <Col lg="6" md="6" sm="12">
                          <Label>Branch Manager</Label>
                          <Input
                            value={s.BMName}
                            onChange={(e) =>
                              onSAChange(idx, "BMName", e.target.value)
                            }
                          />
                        </Col>

                        <Col lg="6" md="6" sm="12">
                          <Label>Contact Number</Label>
                          <PhoneInput
                            inputClass="myphoneinput"
                            country="in"
                            countryCodeEditable={false}
                            value={String(s.contactNumber ?? "")}
                            onChange={(v) =>
                              onSAChange(idx, "contactNumber", String(v))
                            }
                          />
                        </Col>

                        <Col lg="4" md="4" sm="12">
                          <Label>Pincode</Label>
                          <Input
                            type="number"
                            value={s.pincode}
                            onChange={(e) => onSAPincode(idx, e.target.value)}
                            onKeyDown={(e) =>
                              ["e", "E", "+", "-"].includes(e.key) &&
                              e.preventDefault()
                            }
                          />
                        </Col>

                        <Col lg="4" md="4" sm="12">
                          <Label>City</Label>
                          <Input readOnly value={s.city} />
                        </Col>

                        <Col lg="4" md="4" sm="12">
                          <Label>State</Label>
                          <Input readOnly value={s.state} />
                        </Col>

                        <Col lg="12" md="12" sm="12">
                          <Label>Address</Label>
                          <Input
                            value={s.address}
                            onChange={(e) =>
                              onSAChange(idx, "address", e.target.value)
                            }
                          />
                        </Col>

                        <Col lg="12" className="d-flex justify-content-end">
                          {serviceArea.length > 1 && (
                            <Button
                              color="danger"
                              outline
                              onClick={() => removeService(idx)}
                            >
                              Remove
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </div>
                  ))}

                  <div className="d-flex justify-content-end">
                    <Button color="secondary" outline onClick={addService}>
                      + Add Service Location
                    </Button>
                  </div>
                </CardBody>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col className="d-flex justify-content-center">
                <Button
                  color="primary"
                  type="submit"
                  disabled={
                    isCreate
                      ? perms?.Create === false || Loading
                      : perms?.Edit === false || Loading
                  }
                >
                  {Loading ? (
                    <Spinner size="sm" />
                  ) : isCreate ? (
                    "Create"
                  ) : (
                    "Update"
                  )}
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Card>
    </div>
  );
}
